// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 50 ? "views-my" : chunkId) + "." + {"50":"2453036e","51":"3bc502de"}[chunkId] + ".css";
};